export const DONT_SHOW_CONFIRM_KEY = 'dont_show_confirm';
